<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.addNewEmployer_header | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      mat-dialog-close
      [aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <app-input-field
    [control]="form.controls.companyName"
    [icon]="'business'"
    [label]="data.sysText.employerName"
    [inputType]="'string'"
  ></app-input-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      mat-dialog-close
      color="accent"
      [disabled]="isSubmitting">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ data.sysText.add }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

